export default __webpack_public_path__ + "static/media/thanksgiving-appbar-tile.8db094b1.png";